import { ListReportViewSupport4Component } from "../../../components/SupportSystem/Reports/ListReportViewSupport4Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function ListReportViewSupport4Container() {
    const titleName = "รายงานผลการพิจารณาอนุมัติ";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <ListReportViewSupport4Component/>
            <Footer />
        </div>   
        // 
    )
    
}